import { useGetImportLayers } from "fond/hooks/useGetImportLayers";
import { MuPowerOutputLayerIds } from "fond/types";

/**
 * Returns true once the MU_POWER design has produced any output layers.
 */
export const useIsMuPowerDesignComplete = (versionId: string): boolean => {
  const outputLayers = useGetImportLayers(versionId, Object.values(MuPowerOutputLayerIds));
  return Array.from(outputLayers.values()).some((status) => !!status.layer);
};
